module.exports = __webpack_public_path__ + "static/img/development-history.979e316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/development-history.png
// module id = rx30
// module chunks = 1